import './Profile.css';

export const Profile = ({children})=>{
    return(
        <div className='profile'>
            {children}
        </div>
    );
}

